import { useFormContext, Controller } from 'react-hook-form'
import { Spacer, Input } from '@cb/apricot-react'
import { CBInputMethod } from '@cb/apricot'
import { FIELD_EMAIL1, FIELD_EMAIL2 } from '../constants'
import { validateEmail, validateConfirmEmail, validateFieldState } from '../validations'

function EmailAddress({ disabled }) {
  const {
    control,
    watch,
    getValues,
    formState: { defaultValues },
  } = useFormContext()
  const email1Val = watch(FIELD_EMAIL1)
  const confirmationEmailRequired = email1Val !== defaultValues[FIELD_EMAIL1]

  useEffect(() => {
    CBInputMethod()
  }, [])

  return (
    <>
      <Controller
        control={control}
        name={FIELD_EMAIL1}
        rules={{
          required: 'Email address is required',
          validate: value => validateEmail(value),
        }}
        disabled={disabled}
        render={({
          field: { onChange, onBlur, value, disabled, name },
          fieldState: { invalid, isDirty, isTouched, error },
        }) => (
          <Input
            label="Email address"
            name={name}
            value={value}
            onChange={value => onChange(value)}
            onBlur={value => onBlur(value)}
            required
            clearable={false}
            floating={false}
            autoComplete="off"
            maxLength="50"
            disabled={disabled}
            validation={validateFieldState({ invalid, isDirty, isTouched, error, value })}
            validationMsg={error?.message}
          />
        )}
      />
      {confirmationEmailRequired ? (
        <Controller
          control={control}
          name={FIELD_EMAIL2}
          rules={{
            required: {
              value: confirmationEmailRequired,
              message: 'Email address is required',
            },
            validate: value => {
              return validateConfirmEmail
                ? validateConfirmEmail(getValues(FIELD_EMAIL1))(value)
                : undefined
            },
          }}
          disabled={disabled || !confirmationEmailRequired}
          render={({
            field: { onChange, onBlur, value, disabled, name },
            fieldState: { invalid, isDirty, isTouched, error },
          }) => (
            <>
              <Spacer size="24" />
              <Input
                label="Confirm email address"
                name={name}
                value={value}
                onChange={value => onChange(value)}
                onBlur={value => onBlur(value)}
                required
                clearable={false}
                floating={false}
                autoComplete="off"
                maxLength="50"
                disabled={disabled}
                validation={validateFieldState({ invalid, isDirty, isTouched, error, value })}
                validationMsg={error?.message}
              />
            </>
          )}
        />
      ) : null}
    </>
  )
}

export default EmailAddress
